import React from 'react'
import WidgetNode from './WidgetNode'
import WidgetButton from './WidgetButton'
import * as insertExitBlockIfNecessary from '../../slateUtils/insertExitBlockIfNecessary'
import * as WidgetUtils from './WidgetUtils'
const { insertWidget } = WidgetUtils

const prebindProps = (Component, props) =>
  props2 => <Component {...props} {...props2} />

const widgets = {
  Video: {
    title: 'Video'
  },
  SubscribeToNewsletter: {
    title: 'Newsletter Subscribe'
  },
  NewsPR: {
    title: 'OTCM Press Releases'
  },
  NewsIR: {
    title: 'OTCM Investor Relations'
  },
  NewsMedia: {
    title: 'OTCM Media Coverage'
  },
  ATSVolume: {
    title: 'ATS Volume'
  },
  Careers: {
    title: 'Careers Widget'
  }
}

const WidgetSchema = {
  nodes: Object.keys(widgets).reduce((o, key) => ({ ...o, [key]: prebindProps(WidgetNode, widgets[key]) }), {})
}

const hasWidget = (state) => {
  const hasBlock = state.blocks.some(node =>
    node.type in WidgetSchema.nodes)
  return hasBlock
}

const hasWidgetByType = (state, type) => {
  const hasBlock = state.blocks.some(node =>
    node.type === type)
  return hasBlock
}

const widgetTypes = Object.keys(WidgetSchema.nodes)

const hasWidgetByTypeAndKey = (state, type, key) => {
  const hasBlock = state.blocks.some(node =>
    node.type === type && node.key === key)
  return hasBlock
}

const onKeyDown = (event, data, state) => {
  // get this block
  let block
  for (let node of state.blocks) {
    if (widgetTypes.includes(node.type) && node.kind === 'block') {
      block = node
      break
    }
  }

  if (block) {
    let transform = insertExitBlockIfNecessary(block, event, data, state)
    if (transform) {
      return transform.apply()
    }
  }
}

const onClickButton = (e, state, type, isVoid, data) => {
  e.preventDefault()
  return onApply(state, type, isVoid, data)
}

const onApply = (state, type, data = {}) => {
  if (type === 'Video') {
    data.openModal = true
  }

  return insertWidget({state, type, data})
}

const WidgetPlugin = options => {
  return {
    schema: WidgetSchema,
    onKeyDown (...args) {
      return onKeyDown(...args)
    }
  }
}

export {
  widgets,
  widgetTypes,
  hasWidget,
  hasWidgetByType,
  hasWidgetByTypeAndKey,
  onClickButton,
  WidgetPlugin,
  WidgetSchema,
  WidgetNode,
  WidgetButton
}



// WEBPACK FOOTER //
// ./src/components/WidgetSlatePlugin/WidgetSlatePluginContainer.js